import { useEffect } from "react";
import { MessageCircle } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Occasions from "@/components/Occasions";
import Gallery from "@/components/Gallery";
import OrderForm from "@/components/OrderForm";
import Reviews from "@/components/Reviews";
import Footer from "@/components/Footer";
import ErrorBoundary from "@/components/ErrorBoundary";
import PhotoPage from "@/components/PhotoPage";
import { initLenis } from "@/lib/scroll";
import { WHATSAPP_URL } from "@/data/site";
import "@/App.css";

function App() {
    useEffect(() => {
        const destroy = initLenis();
        return destroy;
    }, []);

    return (
        <ErrorBoundary>
            {window.location.pathname.startsWith("/p/") ? (
                <PhotoPage />
            ) : (
            <div className="relative overflow-x-clip bg-cream font-sans text-cocoa antialiased">
                <div aria-hidden className="grain-overlay" />
                <Header />
                <main>
                    <Hero />
                    <Marquee />
                    <Occasions />
                    <Gallery />
                    <OrderForm />
                    <Reviews />
                </main>
                <Footer />
                <a
                    data-testid="floating-whatsapp-btn"
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Chat with Cakes'alot on WhatsApp"
                    className="fixed bottom-5 right-5 z-40 grid size-14 place-items-center rounded-full bg-leaf text-cream shadow-xl shadow-leaf/30 transition-transform duration-200 hover:scale-105 active:scale-95"
                >
                    <MessageCircle className="size-6" />
                </a>
                <Toaster position="top-center" richColors />
            </div>
            )}
        </ErrorBoundary>
    );
}

export default App;
